import {ScenarioListDTO, ScenarioStatus} from 'hemwb-api';
import {formatScenarioExecutionStatusValue} from '../../../../store/scenarioExecution/utils';
import {GridModifier, GridState} from '../../../../store/grid';
import {ScenarioFilter} from './types';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const getScenarioFilterStrategies = (
  listData: ScenarioListDTO | null | undefined,
  reload: () => void,
  gridState: GridState<ScenarioFilter> & GridModifier<ScenarioFilter>,
) => ({
  status: {
    options: Object.values(ScenarioStatus).sort(),
    optionLabel: (k: ScenarioStatus) => formatScenarioExecutionStatusValue(k),
    filter: gridState.filter ? gridState.filter.status : [],
    onSetFilter: (filteredOptions: ScenarioStatus[]) => {
      if (gridState.filter) {
        gridState.setFilter({...gridState.filter, status: filteredOptions});
      }
      reload();
    },
  },
  name: {
    options: listData?.list.map((item) => item.name) || [],
    optionLabel: (k: string) => k,
    filter: gridState.filter ? gridState.filter.name : [],
    onSetFilter: (filteredOptions: string[]) => {
      if (gridState.filter) {
        gridState.setFilter({...gridState.filter, name: filteredOptions});
      }
      reload();
    },
  },
  createdOn: {
    options: Array.from({length: 12}, (_, i) => (i + 1).toString()),
    optionLabel: (k: string) => monthNames[parseInt(k) - 1],
    filter: gridState.filter ? gridState.filter.createdOnMonth : [],
    onSetFilter: (filteredOptions: string[]) => {
      if (gridState.filter) {
        gridState.setFilter({...gridState.filter, createdOnMonth: filteredOptions});
      }
      reload();
    },
  },
  createdBy: {
    options: listData
      ? listData.list.map((item) => item.createdBy?.id).filter((item, pos, self) => item && self.indexOf(item) === pos)
      : [],
    optionLabel: (k: string) => k,
    filter: gridState.filter ? gridState.filter.createdBy : [],
    onSetFilter: (filteredOptions: string[]) => {
      if (gridState.filter) {
        gridState.setFilter({...gridState.filter, createdBy: filteredOptions});
      }
      reload();
    },
  },
});
